import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';
import { ChevronDown, Loader2 } from 'lucide-react';
import api from '../../services/api';

const statusLabels = {
  not_started: 'Not Started',
  in_progress: 'In Progress',
  completed: 'Completed',
  blocked: 'Blocked',
  cancelled: 'Cancelled',
  not_applicable: 'N/A',
};

const PostSaleMatrix = ({ saleId }) => {
  const navigate = useNavigate();
  const [matrix, setMatrix] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get(`/post-sale/matrix?sale_id=${saleId}`);
        setMatrix(res.data || {});
      } catch { /* ignore */ }
      setLoading(false);
    };
    fetch();
  // eslint-disable-next-line
  }, [saleId]);

  if (loading) {
    return <div className="flex justify-center py-8"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  }

  const types = Object.entries(matrix);
  if (types.length === 0) {
    return <p className="text-sm text-muted-foreground italic py-4">No post-sale actions tracked yet</p>;
  }

  return (
    <div className="space-y-1">
      {types.map(([type, data]) => {
        const gapsCount = data.gaps;
        return (
          <Collapsible key={type}>
            <div className="flex items-center justify-between p-2 bg-muted/30 rounded text-sm">
              <span className="font-medium">{data.label}</span>
              <div className="flex items-center gap-2">
                <span className="text-green-600 font-medium">{data.completed}</span>
                <span className="text-muted-foreground">/</span>
                <span className="text-muted-foreground">{data.total}</span>
                {gapsCount > 0 && (
                  <>
                    <Badge variant="outline" className="ml-2 text-xs bg-gray-100">
                      {gapsCount} {gapsCount === 1 ? 'gap' : 'gaps'}
                    </Badge>
                    <CollapsibleTrigger asChild>
                      <Button variant="ghost" size="sm" className="h-6 w-6 p-0">
                        <ChevronDown className="w-3 h-3" />
                      </Button>
                    </CollapsibleTrigger>
                  </>
                )}
              </div>
            </div>
            {gapsCount > 0 && (
              <CollapsibleContent className="pl-4 pt-1">
                <div className="space-y-1 py-2">
                  {data.gap_opportunities.map((item, idx) => (
                    <div
                      key={idx}
                      className="flex items-center justify-between text-xs p-2 bg-white cursor-pointer hover:bg-muted/50 rounded"
                      onClick={() => navigate(`/sales/opportunities/${item.opp_id}`)}
                    >
                      <div className="flex items-center gap-2">
                        <span className="font-medium">#{item.hip_number || 'TBD'}</span>
                        <span className="text-muted-foreground">{item.horse_name}</span>
                      </div>
                      <Badge variant="outline" className="text-xs">
                        {statusLabels[item.status] || item.status}
                      </Badge>
                    </div>
                  ))}
                </div>
              </CollapsibleContent>
            )}
          </Collapsible>
        );
      })}
    </div>
  );
};

export default PostSaleMatrix;
